import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-no-sort",
  "use": "arrow-no-sort-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-no-sort\">\r\n    <path d=\"M11.364 3.78607L8.18609 0.599976M8.18609 0.599976L5 3.78607M8.18609 0.599976V7\" stroke=\"currentColor\" stroke-linejoin=\"round\" />\r\n    <path d=\"M5 12.248L8.17787 15.4341M8.17787 15.4341L11.364 12.248M8.17787 15.4341V9\" stroke=\"currentColor\" stroke-linejoin=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol